const actionType = {
    GET_ALL_VIEW_CONFIGURATION_SUCCESS: 'GET_ALL_VIEW_CONFIGURATION_SUCCESS',
    SET_DYNAMIC_VIEW_CONFIGURATION_SUCCESS: 'SET_DYNAMIC_VIEW_CONFIGURATION_SUCCESS',
};

export default actionType;